export const createColorElement = ({
    id,
    containerClassName,
    colorPickFunc,
    saveFunc,
    saveText,
    clearText,
    colorLabel,
    opacityLabel,
    needBorder = false,
    translate
}) =>
    `<div class="color-container ${containerClassName}">
        ${
            needBorder
                ? `
                    <div class="border-input-container">
                        ${createInput({
                            id,
                            className: 'fr-border-input',
                            name: 'custom-border',
                            labelName: translate('Border Width'),
                            value: '2px',
                            onInput:
                                "this.value = this.value.replace(/[^0-9]/g, '') + (this.value ? 'px' : '0px')",
                            maxLength: '4'
                        })}
                    </div>
                `
                : ''
        }
        <div class="fr-color-set fr-text-color fr-selected-set" style="display: block;${needBorder ? 'padding: 0 20px;' : ''}">
            ${colorPick({ cmd: colorPickFunc, clearLabel: clearText })}
        </div>
        <div class="color-input-container" id="fr-table-colors-hex-layer-${id}" style="display: flex;">
            <div class="fr-color">
                ${createInput({
                    id,
                    className: 'fr-table-colors-hex-layer-text',
                    name: 'table-colors-hex-layer-text',
                    labelName: colorLabel
                })}
            </div>
            <div  class="fr-percentage" style="max-width:64px;">
                ${createInput({
                    id,
                    className: 'fr-padding-input',
                    name: 'table-colors-percentage',
                    labelName: opacityLabel,
                    value: '100%',
                    onInput:
                        "this.value = this.value.replace(/[^0-9]/g, '') + (this.value ? '%' : '0%')",
                    maxLength: '4'
                })}
            </div>
            <div class="fr-action-buttons">
                <button 
                    class="fr-command 
                    fr-submit"  
                    style="min-width:55px;"
                    role="button" 
                    data-cmd="${saveFunc}" 
                    href="#" 
                    type="button"
                >
                    ${saveText}
                </button>
            </div>
        </div>
    </div>`;

export function colorPick({ cmd, clearLabel = 'Clear' }) {
    const colors = [
        '#61BD6D',
        '#1ABC9C',
        '#54ACD2',
        '#2C82C9',
        '#9365B8',
        '#475577',
        '#CCCCCC',
        '#41A85F',
        '#00A885',
        '#3D8EB9',
        '#2969B0',
        '#553982',
        '#28324E',
        '#000000',
        '#F7DA64',
        '#FBA026',
        '#EB6B56',
        '#E25041',
        '#A38F84',
        '#EFEFEF',
        '#FFFFFF',
        '#FAC51C',
        '#F37934',
        '#D14841',
        '#B8312F',
        '#7C706B',
        '#D1D5D8'
    ];
    let colorWall = '';
    for (let i = 0; i < colors.length; i++) {
        const val = colors[i];
        colorWall += `<span class="fr-command fr-select-color" style="background: ${val}" tabindex="-1" aria-selected="false" role="button" data-cmd="${cmd}" data-param1="${val}"><span class="fr-sr-only">Color ${val}&nbsp;&nbsp;&nbsp;</span></span>`;
    }
    colorWall += `<span class="fr-command" data-cmd="${cmd}" tabindex="-1" role="button" data-param1="REMOVE" title="${clearLabel}"><svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z"></path></svg><span class="fr-sr-only">${clearLabel}</span></span>`;
    return colorWall;
}

export function createInput({
    id,
    className,
    name,
    labelName,
    value = '',
    ariaRequired = 'true',
    onInput = '',
    maxLength = ''
}) {
    return `
        <div class="fr-input-line">
            <input 
                id="fr-layer-${name}-${id}" 
                type="text" 
                class=" fr-not-empty ${className}" 
                tabindex="1" 
                dir="ltr" 
                aria-required="${ariaRequired}" 
                ${Boolean(name) ? `name="${name}"` : ''}
                ${Boolean(labelName) ? `placeholder="${labelName}"` : ''}
                ${Boolean(value) ? `value="${value}"` : ''}
                ${Boolean(onInput) ? `oninput="${onInput}"` : ''}
                ${Boolean(maxLength) ? `maxlength="${maxLength}"` : ''}
            >
            <label for="fr-layer-${name}-${id}">${labelName}</label>
      </div>`;
}

export function createCheckbox({ id, className, name, labelName }) {
    return `
        <div class="fr-checkbox-line">
            <span class="fr-checkbox">
                <input 
                    id="fr-layer-checkbox-${name}-${id}" 
                    type="checkbox" 
                    class="fr-not-empty ${className}" 
                    tabindex="1" 
                    aria-required="true" 
                    data-checked="_blank"
                    ${Boolean(name) ? `name="${name}"` : ''}
                >
                <span>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32">
                        <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF">
                        </path>
                    </svg>
                </span>
            </span>
            <label for="fr-layer-checkbox-${name}-${id}">
                ${labelName}
            </label>
        </div>
    `;
}

export function createPadding({
    id,
    translate,
    paddingHorizontalValue,
    paddingVerticalValue,
    borderRadiusValue,
    dataCmd = 'setPadding'
}) {
    return `
            <div class="fr-layer fr-active custom-popup">
                <div style="display: flex;">
                    <div style="width: 50%;margin-right: 20px;">
                        ${createInput({
                            id,
                            className: 'fr-padding-input',
                            name: 'padding-horizontal',
                            labelName: translate('Padding Horizontal'),
                            value: paddingHorizontalValue,
                            onInput:
                                "this.value = this.value.replace(/[^0-9]/g, '') + (this.value ? 'px' : '0px')",
                            maxLength: '4'
                        })}
                    </div>
                    <div style="width: 50%;">
                        ${createInput({
                            id,
                            className: 'fr-padding-input',
                            name: 'padding-vertical',
                            labelName: translate('Padding Vertical'),
                            value: paddingVerticalValue,
                            onInput:
                                "this.value = this.value.replace(/[^0-9]/g, '') + (this.value ? 'px' : '0px')",
                            maxLength: '4'
                        })}
                    </div>
                </div>
                <div class="fr-radius-group">
                    ${createInput({
                        id,
                        className: 'fr-radius-input',
                        name: 'padding-radius',
                        labelName: translate('Border Radius'),
                        value: borderRadiusValue,
                        onInput:
                            "this.value = this.value.replace(/[^0-9]/g, '') + (this.value ? 'px' : '0px')",
                        maxLength: '4'
                    })}
                </div>
                <div class="fr-action-buttons">
                    <button class="fr-command fr-submit" role="button" data-cmd="${dataCmd}" href="#" type="button">
                        ${translate('OK')}
                    </button>
                </div>
            </div>
        `;
}

export const supportAlign = ['left', 'center', 'right'];

/**
 * 建立對齊下拉選單 HTML
 *
 * 此函數用於生成一個包含左對齊、置中對齊和右對齊選項的下拉選單
 *
 * @param {Object} that - 編輯器實例
 * @param {string} dataCmd - 命令名稱
 * @returns {string} 包含對齊選項的下拉選單
 */
export function createAlignDropdown(that, dataCmd) {
    return `<ul class="fr-dropdown-list" role="presentation">
    <li role="presentation">
        <a class="fr-command" tabIndex="-1" role="option" data-cmd="${dataCmd}" data-param1="left" title="${that.language.translate('Align Left')}">
            <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M3,18h6v-2H3V18z M3,11v2h12v-2H3z M3,6v2h18V6H3z"></path>
            </svg>
        </a>
    </li>
    <li role="presentation">
        <a class="fr-command" tabIndex="-1" role="option" data-cmd="${dataCmd}" data-param1="center" title="${that.language.translate('Align Center')}">
            <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M9,18h6v-2H9V18z M6,11v2h12v-2H6z M3,6v2h18V6H3z"></path>
            </svg>
        </a>
    </li>
    <li role="presentation">
        <a class="fr-command" tabIndex="-1" role="option" data-cmd="${dataCmd}" data-param1="right" title="${that.language.translate('Align Right')}">
            <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M15,18h6v-2h-6V18z M9,11v2h12v-2H9z M3,6v2h18V6H3z"></path>
            </svg>
        </a>
    </li>
</ul>`;
}
